import React from 'react';
import appStoreBadge from '../../assets/images/mk/mk-badge-app-store.svg';
import googlePlayBadge from '../../assets/images/mk/mk-badge-google-play.webp';

// Official store badges served from our own build, 48px tall. The alt text is the full link label.
// No hover transform, filter, animation or tilt (Apple / Google badge rules).
const BADGES = {
  appstore: { src: appStoreBadge, width: 144, height: 48 },
  play: { src: googlePlayBadge, width: 161, height: 48 },
};

const MkBadge = ({ store, href, alt, onClick }) => {
  const b = BADGES[store];
  return (
    <a className={`mk-badge mk-badge--${store}`} href={href} onClick={onClick}>
      <img src={b.src} alt={alt} width={b.width} height={b.height} decoding="async" />
    </a>
  );
};

export default MkBadge;
